module.exports = __webpack_public_path__ + "img/contrato.ae07ac1d.svg";